import template from './frequent-orders.html';
export var FrequentOrdersComponent = {
    template: template
};
//# sourceMappingURL=frequent-orders.component.js.map